import { Paper, Box, SxProps, Tooltip } from '@mui/material';
import AppTheme from '../../libs/mui/AppTheme';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useState } from 'react';

export const ClickableCard = (props: {
  children: React.ReactNode;
  onClick?: () => void;
  sxPaper?: SxProps;
  disabled?: boolean;
  disabledMessage?: string;
}) => {
  const { children, onClick, sxPaper, disabled, disabledMessage } = props;
  const shouldShowIcon = onClick !== undefined;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleDisabledClick = () => {
    if (disabled && disabledMessage) {
      setTooltipOpen(true);
      setTimeout(() => setTooltipOpen(false), 2000);
    }
  };

  return (
    <Tooltip
      title={disabledMessage || ''}
      open={tooltipOpen}
      onOpen={() => {
        if (disabled && disabledMessage) setTooltipOpen(true);
      }}
      onClose={() => setTooltipOpen(false)}
      arrow
      placement="bottom"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -20],
              },
            },
          ],
        },
      }}
    >
      <Paper
        sx={{
          position: 'relative',
          padding: 1,
          overflow: 'hidden',
          cursor: onClick && !disabled ? 'pointer' : 'default',
          ...sxPaper,
        }}
        onClick={() => (disabled ? handleDisabledClick() : onClick?.())}
      >
        {disabled && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              cursor: disabled ? 'not-allowed' : 'pointer',
              backgroundColor: 'rgba(0, 0, 0, 0.25)',
              zIndex: 1,
              pointerEvents: 'auto',
              borderRadius: '4px',
            }}
          />
        )}
        {children}
        {shouldShowIcon && (
          <Box
            sx={{
              position: 'absolute',
              borderRadius: '0% 0 0% 7px',
              textAlign: 'center',
              width: '16px',
              height: '16px',
              right: -2,
              top: -2,
              backgroundColor: disabled ? '#737373ff' : '#ff005a',
              display: 'flex',
              alignItems: 'center',
              lineHeight: 0,
              justifyContent: 'center',
            }}
          >
            <ArrowForwardIcon sx={{ color: AppTheme.palette.common.white, fontSize: '14px' }} />
          </Box>
        )}
      </Paper>
    </Tooltip>
  );
};
